import { getAppConfig } from 'app/getConfig';

export const isAdminUI = window.location.origin === getAppConfig().ADMIN_UI_URL;
export const isReportUI = window.location.origin === getAppConfig().REPORT_UI_URL;
